import { useCanSeeAspenWeb } from '@solinkcorp/authentication';
import { type ComponentType, type FC } from 'react';

/**
 * Pick the Aspen redesign variant when `useCanSeeAspenWeb()` is true, otherwise
 * the legacy component. Call this only at selection points (page wrappers /
 * composed HOCs) — never inside leaf components.
 *
 * Same shape as the ternary in `NavigationFrame.tsx`.
 */
export function withAspen<P extends object>(
  Legacy: ComponentType<P>,
  Aspen: ComponentType<P>,
): FC<P> {
  function AspenGated(props: P) {
    return useCanSeeAspenWeb() ? <Aspen {...props} /> : <Legacy {...props} />;
  }

  AspenGated.displayName = `withAspen(${
    Aspen.displayName || Aspen.name || Legacy.displayName || Legacy.name || 'Component'
  })`;

  return AspenGated;
}
